<div *ngIf="!error && !isLoading && patientGroups && patientGroups.length > 0; else innerLoading"
  id="patient-group-list">

  <table class="table" >
    <thead>
      <tr>
        <th scope="col">Groupe</th>
        <th scope="col">Dernière activité</th>
        <th scope="col" id="patients-col">Patients</th>
        <th scope="col" id="actions-col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr patient-group-row *ngFor="let grp of patientGroups"
        [patientGroup]="grp"
        [class.selected]="selection === grp.id.toString()"
        (click)="onSelect.emit(grp)"
        (onEdit)="onEdit.emit(grp)"
        (onDelete)="onDelete.emit(grp)"></tr>
    </tbody>
  </table>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading class="flex-center" [empty]="patientGroups?.length === 0" [error]="!!error"
    [loading]="isLoading" (retry)="loadPatientGroups()" [loadingDescription]="'Chargement...'"
    [emptyDescription]="'Aucun groupe'"
    [errorDescription]="error" [retryButtonText]="'Réessayer'">
  </ngx-inner-loading>
</ng-template>
